import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'

Vue.use(VueRouter)

// const messageErrorTip = msg => {
//   Message.error({
//     showClose: true,
//     message: msg,
//     dangerouslyUseHTMLString: true,
//     customClass: 'custom_message'
//   })
// }

const messageWarningTip = msg => {
  Message.warning({
    showClose: true,
    message: msg,
    dangerouslyUseHTMLString: true,
    customClass: 'custom_message'
  })
}

const routes = [
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/Main.vue'),
    meta: { requiresAuth: true, title: '企业投票云服务', role: 'user' },
    children: [
      // 会议/活动
      {
        path: '/meetingList',
        name: 'meetingList',
        component: () => import('../views/main/meeting/Index.vue'),
        meta: { title: '会议/活动' }
      },
      // 个人资料
      {
        path: '/personal',
        name: 'personal',
        component: () => import('../views/main/personal/Index.vue'),
        meta: { title: '个人资料' },
        children: [
          {
            path: '/personal/moneyOrders',
            name: 'moneyOrders',
            component: () => import('../views/main/personal/MoneyOrders.vue'),
            meta: { title: '购买纪录' }
          },
          {
            path: '/personal/moneyUsering',
            name: 'moneyUsering',
            component: () => import('../views/main/personal/MoneyUsering.vue'),
            meta: { title: '使用纪录' }
          },
          {
            path: '/personal/userManage',
            name: 'userManage',
            component: () => import('../views/main/personal/UserManage.vue'),
            meta: { title: '用户管理' }
          },
          {
            path: '/personal/recharge',
            name: 'recharge',
            component: () => import('../views/main/personal/Recharge.vue'),
            meta: { title: '充值' }
          }
        ]
      },
      // 充值中心
      {
        path: '/financial',
        name: 'financial',
        component: () => import('../views/main/financial/Index.vue'),
        meta: { title: '充值中心' }
      },
      // 充值回调
      {
        path: '/alipayReturn',
        name: 'alipayReturn',
        component: () => import('../views/main/financial/AlipayReturn.vue'),
        meta: { title: '充值中心' }
      },
      // 用户管理
      {
        path: '/user',
        name: 'user',
        component: () => import('../views/main/user/Index.vue'),
        meta: { title: '用户管理' }
      },
      // 公司管理
      {
        path: '/company',
        name: 'company',
        component: () => import('../views/main/user/Company.vue'),
        meta: { title: '公司管理' }
      },
      // 人员职位查询
      {
        path: '/userPostQuery',
        name: 'userPostQuery',
        component: () => import('../views/main/user/UserPostQuery.vue'),
        meta: { title: '人员职位查询' }
      },
      // 公司用户管理
      {
        path: '/companyUser/:cid',
        name: 'companyUser',
        component: () => import('../views/main/user/CompanyUser.vue'),
        meta: { title: '公司用户管理' }
      },
      // 注销账户
      {
        path: '/cancelAccount',
        name: 'cancelAccount',
        component: () => import('../views/main/CancelAccount.vue'),
        meta: { title: '帐号注销' }
      }
    ]
  },
  // 投票明细
  {
    path: '/voteDetail1/:mid/:vid/:s/:m',
    name: 'voteDetail1',
    component: () => import('../views/meetingHome/vote/watchVote/VoteDetail.vue'),
    meta: { title: '投票明细' }
  },
  {
    path: '/m',
    name: 'meeting',
    component: () => import(/* webpackChunkName: "MeetingHome" */ '../views/MeetingHome.vue'),
    meta: { requiresAuth: true, title: '会议/活动', role: 'user' },
    children: [
      // 基本信息
      {
        path: '/m/basic/:mid',
        name: 'meetingBasic',
        component: () => import('../views/meetingHome/basicInfo/Index.vue'),
        meta: { title: '基本信息' }
      },
      // 报名管理
      {
        path: '/m/userApplyManager/:mid',
        name: 'userApplyManager',
        component: () => import('../views/meetingHome/userApply/Index.vue'),
        meta: { title: '报名管理' }
      },
      // 发票信息
      {
        path: '/m/invoiceManager/:mid',
        name: 'invoiceManager',
        component: () => import('../views/meetingHome/invoice/InvoiceManager.vue'),
        meta: { title: '发票信息' }
      },
      // 参会回执信息
      {
        path: '/m/meetingReceipt/:mid',
        name: 'meetingReceipt',
        component: () => import('../views/meetingHome/meetingReceipt/MeetingReceipt.vue'),
        meta: { title: '参会回执信息' }
      },
      // 投票人员分组
      {
        path: '/m/voteUserGroup/:mid/:vid',
        name: 'voteUserGroup',
        component: () => import('../views/meetingHome/voteUser/UserGroupManager.vue'),
        meta: { title: '投票人员' }
      },
      // 投票人员
      {
        path: '/m/voteUser/:mid/:gid/:vid',
        name: 'voteUser',
        component: () => import('../views/meetingHome/voteUser/UserManager.vue'),
        meta: { title: '投票人员' }
      },
      // 待评项目
      {
        path: '/m/voteProjectGroup/:mid/:vid',
        name: 'voteProjectGroup',
        component: () => import('../views/meetingHome/voteProject/ProjectGroupManager.vue'),
        meta: { title: '待评项目' }
      },
      // 待评项目
      {
        path: '/m/voteProject/:mid/:gid/:vid',
        name: 'voteProject',
        component: () => import('../views/meetingHome/voteProject/ProjectManager.vue'),
        meta: { title: '待评项目' }
      },
      // 投票规则
      {
        path: '/m/voteRule/:mid',
        name: 'voteRule',
        component: () => import('../views/meetingHome/voteRule/Index.vue'),
        meta: { title: '投票规则' }
      },
      // 投票管理
      {
        path: '/m/vote/:mid',
        name: 'meetingVote',
        component: () => import('../views/meetingHome/vote/Index.vue'),
        meta: { title: '投票管理' }
      },
      // 投票监控
      {
        path: '/m/watchVote/:mid/:vid/:votetype',
        name: 'watchVote',
        component: () => import('../views/meetingHome/vote/watchVote/WatchVote.vue'),
        meta: { title: '投票监控' },
        children: [
          // 投票明细
          {
            path: '/m/watchVote/voteDetail/:mid/:vid/:votetype',
            name: 'voteDetail',
            component: () => import('../views/meetingHome/vote/watchVote/VoteDetail.vue'),
            meta: { title: '投票明细' }
          },
          // 投票明细
          {
            path: '/m/watchVote/voteDetails/:mid/:vid/:votetype',
            name: 'voteDetails',
            component: () => import('../views/meetingHome/vote/watchVote/voteDetails.vue'),
            meta: { title: '投票明细' }
          },
          // 打分投票明细
          {
            path: '/m/watchVote/voteScoreDetails/:mid/:vid/:votetype',
            name: 'voteScoreDetails',
            component: () => import('../views/meetingHome/vote/watchVote/VoteScoreDetails.vue'),
            meta: { title: '打分投票明细' }
          },
          // 投票结果
          {
            path: '/m/watchVote/voteResult/:mid/:vid/:votetype',
            name: 'voteResult',
            component: () => import('../views/meetingHome/vote/watchVote/VoteResult.vue'),
            meta: { title: '投票结果' }
          },
          // 检查投票进度
          {
            path: '/m/watchVote/voteProgress/:mid/:vid/:votetype',
            name: 'voteProgress',
            component: () => import('../views/meetingHome/vote/watchVote/VoteProgress.vue'),
            meta: { title: '检查投票进度' }
          },
          {
            path: '/m/watchVote/voteScreenResult/:mid/:vid/:votetype',
            name: 'voteScreenResult',
            component: () => import('../views/meetingHome/vote/screenPC/ScreenResult.vue'),
            meta: { title: '投屏结果' }
          }
        ]
      },
      {
        path: '/m/wj/manage/watchQuestionnaire/:mid/:qid',
        name: 'voteWatchQuestionnaire',
        component: () => import('../views/wj/manage/questionnaire/watch/Index.vue'),
        meta: { title: '问卷监控' },
        children: [
          // 明细
          {
            path: '/m/wj/manage/watchQuestionnaire/details1/:mid/:qid',
            name: 'voteQuestionnaireDetails1',
            component: () => import('../views/wj/manage/questionnaire/watch/Details.vue'),
            meta: { title: '问卷明细' }
          },
          // 明细
          {
            path: '/m/wj/manage/watchQuestionnaire/details/:mid/:qid',
            name: 'voteQuestionnaireDetails',
            component: () => import('../views/wj/manage/questionnaire/watch/TableDetails.vue'),
            meta: { title: '问卷明细' }
          },
          // 问卷结果
          {
            path: '/m/wj/manage/watchQuestionnaire/result/:mid/:qid',
            name: 'votQuestionnaireResult',
            component: () => import('../views/wj/manage/questionnaire/watch/Result.vue'),
            meta: { title: '问卷结果' }
          },
          // 检查问卷进度
          {
            path: '/m/wj/manage/watchQuestionnaire/progress/:mid/:qid',
            name: 'voteQuestionnaireProgress',
            component: () => import('../views/wj/manage/questionnaire/watch/Progress.vue'),
            meta: { title: '检查问卷进度' }
          }
        ]
      },
      // 投屏结果
      {
        path: '/m/voteSetting/:mid/:vid',
        name: 'voteSetting',
        component: () => import('../views/meetingHome/vote/EditVoteSetting.vue'),
        meta: { title: '投票配置信息' }
      },
      {
        path: '/m/voteResultsSummary/:mid',
        name: 'voteResultsSummary',
        component: () => import('../views/meetingHome/vote/watchVote/VoteResultsSummary.vue'),
        meta: { title: '投票结果汇总' }
      },
      {
        path: '/m/voteGuidePage/:mid/:vid/:votetype',
        name: 'voteGuidePage',
        component: () => import('../views/meetingHome/vote/VoteGuidePage.vue'),
        meta: { title: '投票引导' }
      },
      // 创建投票
      {
        path: '/m/createVote/:mid/:vid/:qid',
        name: 'createVote',
        component: () => import('../views/meetingHome/vote/EditVote.vue'),
        meta: { title: '创建投票' },
        children: [
          // 创建投票-基本信息
          {
            path: '/m/createVote/basic/:mid/:vid/:qid',
            name: 'createVoteBasic',
            component: () => import('../views/meetingHome/vote/EditVoteBasic.vue'),
            meta: { title: '创建投票-基本信息' }
          },
          // 创建投票-投票项目
          {
            path: '/m/createVote/project/:mid/:vid/:qid',
            name: 'createVoteProject',
            component: () => import('../views/meetingHome/vote/EditVoteProject.vue'),
            meta: { title: '创建投票-投票项目' }
          },
          // 创建投票-投票用户
          {
            path: '/m/createVote/user/:mid/:vid/:qid',
            name: 'createVoteUser',
            component: () => import('../views/meetingHome/vote/EditVoteUser.vue'),
            meta: { title: '创建投票-投票用户' }
          },
          // 创建投票-问卷项目
          {
            path: '/m/createVote/body/:mid/:vid/:qid',
            name: 'createVoteBody',
            component: () => import('../views/meetingHome/vote/EditQuestionnaireBody.vue'),
            meta: { title: '创建投票-投票项目' }
          },
          // 创建投票-投票用户
          {
            path: '/m/createVote/qauser/:mid/:vid/:qid',
            name: 'createVoteQAUser',
            component: () => import('../views/meetingHome/vote/EditQuestionnaireUser.vue'),
            meta: { title: '创建投票-投票用户' }
          }
        ]
      },
      {
        path: '/m/editVote/:mid/:vid/:qid',
        name: 'editVote',
        component: () => import('../views/meetingHome/vote/EditVote.vue'),
        meta: { title: '编辑投票' },
        children: [
          // 编辑投票-基本信息
          {
            path: '/m/editVote/basic/:mid/:vid/:qid',
            name: 'editVoteBasic',
            component: () => import('../views/meetingHome/vote/EditVoteBasic.vue'),
            meta: { title: '编辑投票-基本信息' }
          },
          // 编辑投票-投票项目
          {
            path: '/m/editVote/project/:mid/:vid/:qid',
            name: 'editVoteProject',
            component: () => import('../views/meetingHome/vote/EditVoteProject.vue'),
            meta: { title: '编辑投票-投票项目' }
          },
          // 编辑投票-投票用户
          {
            path: '/m/editVote/user/:mid/:vid/:qid',
            name: 'editVoteUser',
            component: () => import('../views/meetingHome/vote/EditVoteUser.vue'),
            meta: { title: '编辑投票-投票用户' }
          },
          // 编辑投票-问卷项目
          {
            path: '/m/editVote/body/:mid/:vid/:qid',
            name: 'editVoteBody',
            component: () => import('../views/meetingHome/vote/EditQuestionnaireBody.vue'),
            meta: { title: '编辑投票-投票项目' }
          },
          // 编辑投票-投票用户
          {
            path: '/m/editVote/qauser/:mid/:vid/:qid',
            name: 'editVoteQAUser',
            component: () => import('../views/meetingHome/vote/EditQuestionnaireUser.vue'),
            meta: { title: '编辑投票-投票用户' }
          }
        ]
      },
      {
        path: '/m/p/editVote/:mid/:vid',
        name: 'editPublicVote',
        component: () => import('../views/meetingHome/vote/public/EditVote.vue'),
        meta: { title: '编辑投票' },
        children: [
          // 编辑投票-基本信息
          {
            path: '/m/p/editVote/basic/:mid/:vid',
            name: 'editPublicVoteBasic',
            component: () => import('../views/meetingHome/vote/public/EditVoteBasic.vue'),
            meta: { title: '编辑投票-基本信息' }
          },
          // 编辑投票-投票项目
          {
            path: '/m/p/editVote/project/:mid/:vid',
            name: 'editPublicVoteProject',
            component: () => import('../views/meetingHome/vote/public/EditVoteProject.vue'),
            meta: { title: '编辑投票-投票项目' }
          },
          // 编辑投票-其它配置
          {
            path: '/m/p/editVote/setting/:mid/:vid',
            name: 'editPublicVoteSetting',
            component: () => import('../views/meetingHome/vote/public/EditVoteSetting.vue'),
            meta: { title: '编辑投票-其它配置' }
          }
        ]
      },
      {
        path: '/m/p/watchVote/voteDetails/:mid/:vid/:votetype',
        name: 'publicVoteDetails',
        component: () => import('../views/meetingHome/vote/public/watchVote/voteDetails.vue'),
        meta: { title: '投票明细' }
      },
      // 投票结果
      {
        path: '/m/p/watchVote/voteResult/:mid/:vid/:votetype',
        name: 'publicVoteResult',
        component: () => import('../views/meetingHome/vote/public/watchVote/VoteResult.vue'),
        meta: { title: '投票结果' }
      },
      {
        path: '/m/p/voteProjectGroup/:mid/:vid',
        name: 'publicVoteProjectGroup',
        component: () => import('../views/meetingHome/voteProject/ProjectGroupManager.vue'),
        meta: { title: '投票选项' }
      },
      // 投票选项
      {
        path: '/m/p/voteProject/:mid/:gid/:vid',
        name: 'publicVoteProject',
        component: () => import('../views/meetingHome/voteProject/ProjectManager.vue'),
        meta: { title: '投票选项' }
      },
      {
        path: '/m/editVote1/:mid/:vid',
        name: 'editVote1',
        component: () => import('../views/meetingHome/vote/EditVote1.vue'),
        meta: { title: '编辑投票' },
        children: [
          // 编辑投票-基本信息
          {
            path: '/m/editVote1/basic/:mid/:vid',
            name: 'editVoteBasic1',
            component: () => import('../views/meetingHome/vote/EditVoteBasic.vue'),
            meta: { title: '编辑投票-基本信息' }
          },
          // 编辑投票-投票项目
          {
            path: '/m/editVote1/project/:mid/:vid',
            name: 'editVoteProject1',
            component: () => import('../views/meetingHome/vote/EditVoteProject.vue'),
            meta: { title: '编辑投票-投票项目' }
          },
          // 编辑投票-投票用户
          {
            path: '/m/editVote1/user/:mid/:vid',
            name: 'editVoteUser1',
            component: () => import('../views/meetingHome/vote/EditVoteUser.vue'),
            meta: { title: '编辑投票-投票用户' }
          }
        ]
      }
    ]
  },
  {
    path: '/userPrint/:mid/:gid/:vn/:tip',
    name: 'userPrint',
    component: () => import('../views/meetingHome/voteUser/UserPrint.vue'),
    meta: { requiresAuth: true, title: '账号打印', role: 'user' }
  },
  {
    path: '/userSinglePrint/:mid/:gid/:vn/:tip/:sn',
    name: 'userSinglePrint',
    component: () => import('../views/meetingHome/voteUser/UserSinglePrint.vue'),
    meta: { requiresAuth: true, title: '账号打印', role: 'user' }
  },
  {
    path: '/',
    name: '/',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务-登录' }
    // children: [
    //   // 产品推广--首页
    //   {
    //     path: '/home',
    //     name: 'home',
    //     component: () => import('../views/brand/Home.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选' }
    //   },
    //   // 产品推广--场景介绍
    //   {
    //     path: '/scene',
    //     name: 'scene',
    //     component: () => import('../views/brand/Scene.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务 - 场景介绍' }
    //   },
    //   // 产品推广--成功案例
    //   {
    //     path: '/case',
    //     name: 'case',
    //     component: () => import('../views/brand/Case.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务 - 成功案例' }
    //   },
    //   // 产品推广--教程讲解
    //   {
    //     path: '/course',
    //     name: 'course',
    //     component: () => import('../views/brand/Course.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务 - 教程讲解' }
    //   },
    //   // 产品推广--资费介绍
    //   {
    //     path: '/fee',
    //     name: 'fee',
    //     component: () => import('../views/brand/Fee.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务 - 资费介绍' }
    //   },
    //   // 产品推广--关于我们
    //   {
    //     path: '/about',
    //     name: 'about',
    //     component: () => import('../views/brand/About.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务 - 关于我们' }
    //   },
    //   // 登录
    //   {
    //     path: '/login/:loginType',
    //     name: 'login',
    //     component: () => import('../views/Login.vue'),
    //     meta: { requiresAuth: false, title: '企业投票云服务 - 登录' }
    //   },
    //   {
    //     path: '/style',
    //     name: 'style',
    //     component: () => import('../views/webStyle.vue'),
    //     meta: { requiresAuth: false, title: '网站样式' }
    //   },
    //   // 绑定手机号
    //   {
    //     path: '/bind-mobile',
    //     name: 'bind-mobile',
    //     component: () => import('../views/BindMobile.vue'),
    //     meta: { requiresAuth: false, title: '新用户注册 绑定手机号' }
    //   }
    // ]
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/brand/Home.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务-专为投票场景打造，支持职称评定投票、项目评优、奖励申报、评先进、股东大会、党代表选举、政协会议表决、人事任免、干部考核、优秀员工评选' }
  },
  {
    path: '/scene',
    name: 'scene',
    component: () => import('../views/brand/Scene.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 场景介绍' }
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('../views/brand/Case.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 成功案例' }
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/brand/Course.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 教程讲解' }
  },
  {
    path: '/fee',
    name: 'fee',
    component: () => import('../views/brand/Fee.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 资费介绍' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/brand/About.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 关于我们' }
  },
  {
    path: '/login/:loginType',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 登录' }
  },
  {
    path: '/wx_login',
    name: 'wxlogin',
    component: () => import('../views/WXLogin.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 登录' }
  },
  {
    path: '/qywx_login',
    name: 'qywxlogin',
    component: () => import('../views/QYWXLogin.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 登录' }
  },
  {
    path: '/cloud/login',
    name: 'cloudLogin',
    component: () => import('../views/CloudLogin.vue'),
    meta: { requiresAuth: false, title: '企业投票云服务 - 快捷登录' }
  },
  {
    path: '/style',
    name: 'style',
    component: () => import('../views/webStyle.vue'),
    meta: { requiresAuth: false, title: '网站样式' }
  },
  {
    path: '/bind-mobile',
    name: 'bind-mobile',
    component: () => import('../views/BindMobile.vue'),
    meta: { requiresAuth: false, title: '新用户注册 绑定手机号' }
  },
  {
    path: '/largeScreen/:vid',
    name: 'largeScreen',
    component: () => import('../views/meetingHome/vote/screenPC/LargeScreen.vue'),
    meta: { requiresAuth: false, title: '大屏幕' }
  },
  {
    path: '/shortlistedScreen/:vid',
    name: 'shortlistedScreen',
    component: () => import('../views/meetingHome/vote/screenPC/ShortlistedScreen.vue'),
    meta: { requiresAuth: false, title: '大屏幕' }
  },
  {
    path: '/mobileVote',
    name: 'mobileVote',
    component: () => import('../views/mobileVote/index.vue'),
    meta: { requiresAuth: false, title: '投票', role: 'voter' },
    children: [
      // 投票-问卷
      {
        path: '/mobileVote/wenjuan/:mid/:vid/:token',
        name: 'wenjuan',
        component: () => import('../views/mobileVote/VoteWenJuan.vue'),
        meta: { requiresAuth: false, title: ' ' }
      },
      // 投票-报名
      {
        path: '/mobileVote/voteUserApply/:mid/:cid',
        name: 'voteUserApply',
        component: () => import('../views/mobileVote/VoteUserApply.vue'),
        meta: { requiresAuth: false, title: ' 投票-报名' }
      },
      // 投票-投票登录
      {
        path: '/mobileVote/voteLogin/:mid/:cid',
        name: 'voteLogin',
        component: () => import('../views/mobileVote/voteLogin.vue'),
        meta: { requiresAuth: false, title: ' 投票-投票登录' }
      },
      // 投票-投票列表
      {
        path: '/mobileVote/voteList/:mid',
        name: 'voteList',
        component: () => import('../views/mobileVote/voteList.vue'),
        meta: { requiresAuth: true, title: '投票-投票列表' }
      },
      // 投票-主持人-投票项目
      {
        path: '/mobileVote/chairScreenProjects/:mid/:vid',
        name: 'chairScreenProjects',
        component: () => import('../views/mobileVote/screen/chairScreenProjects.vue'),
        meta: { requiresAuth: true, title: '投票-主持人-投票项目' }
      },
      // 投票-主持人-投票控制台
      {
        path: '/mobileVote/chairScreenControl/:mid/:vid/:gid/:pid',
        name: 'chairScreenControl',
        component: () => import('../views/mobileVote/screen/chairScreenControl.vue'),
        meta: { requiresAuth: true, title: '投票-主持人-投票控制台' }
      },
      // 投票-查看投票页面
      {
        path: '/mobileVote/mobileWatchScreenVote/:mid/:vid',
        name: 'mobileWatchScreenVote',
        component: () => import('../views/mobileVote/screen/watchVote.vue'),
        meta: { requiresAuth: true, title: '投票-查看投票页面' }
      },
      // 投票-投票人-投票页面
      {
        path: '/mobileVote/judgeVote/:mid/:vid',
        name: 'judgeVote',
        component: () => import('../views/mobileVote/screen/judgeVote.vue'),
        meta: { requiresAuth: true, title: '投票-投票人-投票页面' }
      },
      // 投票-入围投票
      {
        path: '/mobileVote/shortlist/:mid/:vid',
        name: 'shortlist',
        component: () => import('../views/mobileVote/Shortlist.vue'),
        meta: { requiresAuth: true, title: '投票-入围投票' }
      },
      // 投票-入围投票-主持人
      {
        path: '/mobileVote/chairShortlistedScreen/:mid/:vid',
        name: 'chairShortlistedScreen',
        component: () => import('../views/mobileVote/screen/chairShortlistedScreen.vue'),
        meta: { requiresAuth: true, title: '投票-入围投票' }
      },
      // 投票-颁奖典礼-主持人
      {
        path: '/mobileVote/chairAwardCeremonyList/:mid/:vid',
        name: 'chairAwardCeremonyList',
        component: () => import('../views/mobileVote/screen/awardCeremony.vue'),
        meta: { requiresAuth: true, title: '投票-颁奖典礼' }
      },
      // 投票-排序投票
      {
        path: '/mobileVote/sort/:mid/:vid',
        name: 'sort',
        component: () => import('../views/mobileVote/Sort.vue'),
        meta: { requiresAuth: true, title: '投票-排序投票' }
      },
      // 投票-打分投票
      {
        path: '/mobileVote/score/:mid/:vid',
        name: 'score',
        component: () => import('../views/mobileVote/Score.vue'),
        meta: { requiresAuth: true, title: '投票-打分投票' }
      },
      // 投票-打分投票
      {
        path: '/mobileVote/result/:mid/:vid/:voteType',
        name: 'result',
        component: () => import('../views/mobileVote/Result.vue'),
        meta: { requiresAuth: true, title: '投票-投票结果' }
      },
      // 投票-打分投票
      {
        path: '/mobileVote/mobileWatchVote/:mid/:vid',
        name: 'mobileWatchVote',
        component: () => import('../views/mobileVote/WatchVote.vue'),
        meta: { requiresAuth: true, title: '投票-打分投票' }
      }
    ]
  },
  {
    path: '/manua',
    name: 'manua',
    component: () => import('../views/Manua.vue'),
    meta: { requiresAuth: false, title: '用户手册' }
  },
  {
    path: '/wj/manage',
    name: 'wj_manage',
    component: () => import('../views/wj/manage/Index.vue'),
    meta: { requiresAuth: false, title: '考试问卷' },
    children: [
      // 基本信息
      {
        path: '/wj/manage/basic/:mid',
        name: 'wj_manageBasic',
        component: () => import('../views/wj/manage/basicInfo/Index.vue'),
        meta: { title: '基本信息' }
      },
      // 报名管理
      {
        path: '/wj/manage/userApplyManager/:mid',
        name: 'wjUserApplyManager',
        component: () => import('../views/wj/manage/userApply/Index.vue'),
        meta: { title: '报名管理' }
      },
      // 答卷人员分组
      {
        path: '/wj/manage/userGroup/:mid',
        name: 'wjUserGroup',
        component: () => import('../views/wj/manage/users/UserGroupManager.vue'),
        meta: { title: '投票人员' }
      },
      // 答卷人员
      {
        path: '/wj/manage/user/:mid/:gid',
        name: 'wjUser',
        component: () => import('../views/wj/manage/users/UserManager.vue'),
        meta: { title: '投票人员' }
      },
      // 题库
      {
        path: '/wj/manage/questionBank/:cid/:mid',
        name: 'questionBankManage',
        component: () => import('../views/wj/manage/questions/questionBankManage.vue'),
        meta: { title: '题库管理' }
      },
      // 题目管理
      {
        path: '/wj/manage/question/:cid/:mid/:gid',
        name: 'questionManage',
        component: () => import('../views/wj/manage/questions/questionManage.vue'),
        meta: { title: '题目管理' }
      },
      // 结果汇总
      {
        path: '/wj/manage/resultsSummary/:mid',
        name: 'questionnaireResultsSummary',
        component: () => import('../views/wj/manage/resultsSummary/Index.vue'),
        meta: { title: '结果汇总' }
      },
      // 问卷管理
      {
        path: '/wj/manage/questionnaire/:mid',
        name: 'questionnaireManage',
        component: () => import('../views/wj/manage/questionnaire/Index.vue'),
        meta: { title: '问卷管理' }
      },
      // 创建问卷
      {
        path: '/wj/manage/createQuestionnaire/:mid/:qid',
        name: 'createQuestionnaire',
        component: () => import('../views/wj/manage/questionnaire/EditQuestionnaire.vue'),
        meta: { title: '创建问卷' },
        children: [
          // 创建问卷-基本信息
          {
            path: '/wj/manage/createQuestionnaire/basic/:mid/:qid',
            name: 'createQuestionnaireBasic',
            component: () => import('../views/wj/manage/questionnaire/EditQuestionnaireBasic.vue'),
            meta: { title: '创建问卷-基本信息' }
          },
          // 创建问卷-问卷项目
          {
            path: '/wj/manage/createQuestionnaire/body/:mid/:qid',
            name: 'createQuestionnaireBody',
            component: () => import('../views/wj/manage/questionnaire/EditQuestionnaireBody.vue'),
            meta: { title: '创建问卷-问卷项目' }
          },
          // 创建问卷-问卷用户
          {
            path: '/wj/manage/createQuestionnaire/user/:mid/:qid',
            name: 'createQuestionnaireUser',
            component: () => import('../views/wj/manage/questionnaire/EditQuestionnaireUser.vue'),
            meta: { title: '创建问卷-问卷用户' }
          }
        ]
      },
      {
        path: '/wj/manage/editQuestionnaire/:mid/:qid',
        name: 'editQuestionnaire',
        component: () => import('../views/wj/manage/questionnaire/EditQuestionnaire.vue'),
        meta: { title: '编辑问卷' },
        children: [
          // 编辑问卷-基本信息
          {
            path: '/wj/manage/editQuestionnaire/basic/:mid/:qid',
            name: 'editQuestionnaireBasic',
            component: () => import('../views/wj/manage/questionnaire/EditQuestionnaireBasic.vue'),
            meta: { title: '编辑投票-基本信息' }
          },
          // 编辑问卷-问卷项目
          {
            path: '/wj/manage/editQuestionnaire/body/:mid/:qid',
            name: 'editQuestionnaireBody',
            component: () => import('../views/wj/manage/questionnaire/EditQuestionnaireBody.vue'),
            meta: { title: '编辑问卷-问卷项目' }
          },
          // 编辑问卷-问卷用户
          {
            path: '/wj/manage/editQuestionnaire/user/:mid/:qid',
            name: 'editQuestionnaireUser',
            component: () => import('../views/wj/manage/questionnaire/EditQuestionnaireUser.vue'),
            meta: { title: '编辑问卷-问卷用户' }
          }
        ]
      },
      {
        path: '/wj/manage/watchQuestionnaire/:mid/:qid',
        name: 'watchQuestionnaire',
        component: () => import('../views/wj/manage/questionnaire/watch/Index.vue'),
        meta: { title: '问卷监控' },
        children: [
          // 明细
          {
            path: '/wj/manage/watchQuestionnaire/details/:mid/:qid',
            name: 'questionnaireDetails',
            component: () => import('../views/wj/manage/questionnaire/watch/Details.vue'),
            meta: { title: '问卷明细' }
          },
          // 问卷结果
          {
            path: '/wj/manage/watchQuestionnaire/result/:mid/:qid',
            name: 'questionnaireResult',
            component: () => import('../views/wj/manage/questionnaire/watch/Result.vue'),
            meta: { title: '问卷结果' }
          },
          // 检查问卷进度
          {
            path: '/wj/manage/watchQuestionnaire/progress/:mid/:qid',
            name: 'questionnaireProgress',
            component: () => import('../views/wj/manage/questionnaire/watch/Progress.vue'),
            meta: { title: '检查问卷进度' }
          }
        ]
      },
      {
        path: '/wj/manage/questionnaireGuidePage/:mid/:qid/:type',
        name: 'questionnaireGuidePage',
        component: () => import('../views/wj/manage/questionnaire/GuidePage.vue'),
        meta: { title: '投票引导' }
      }
    ]
  },
  {
    path: '/wj/answer',
    name: 'wj_answer',
    component: () => import('../views/wj/answer/Index.vue'),
    meta: { requiresAuth: false, title: '答卷', role: 'wj_answer' },
    children: [
      // 问卷登录
      {
        path: '/wj/answer/login/:cid/:mid/:qid',
        name: 'answerLogin',
        component: () => import('../views/wj/answer/Login.vue'),
        meta: { requiresAuth: false, title: ' 问卷登录' }
      },
      // 问卷列表
      {
        path: '/wj/answer/questionnaireList/:mid',
        name: 'answerQuestionnaireList',
        component: () => import('../views/wj/answer/QuestionnaireList.vue'),
        meta: { requiresAuth: true, title: '问卷列表' }
      },
      // 填写问卷
      {
        path: '/wj/answer/answerPaper/:cid/:mid/:qid/:aid/:s',
        name: 'answerPaper',
        component: () => import('../views/wj/answer/AnswerPaper.vue'),
        meta: { requiresAuth: true, title: '填写问卷' }
      },
      // 问卷-已提交
      {
        path: '/wj/answer/completeAnswerPaper/:cid/:mid/:qid/:aid/:s',
        name: 'completeAnswerPaper',
        component: () => import('../views/wj/answer/CompleteAnswerPaper.vue'),
        meta: { requiresAuth: true, title: '问卷-已提交' }
      },
      // 答卷列表
      {
        path: '/wj/answer/markingAnswerPaperList/:cid/:mid/:qid/:s',
        name: 'markingAnswerPaperList',
        component: () => import('../views/wj/answer/MarkingAnswerPaperList.vue'),
        meta: { requiresAuth: true, title: '答卷列表' }
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: '/vw',
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const state = JSON.parse(window.localStorage.getItem('state'))
    if (!state || state === null) {
      messageWarningTip('无权访问，请先登录！')
      if (to.matched.some(record => record.meta.role === 'user')) {
        next({ name: 'login', params: { loginType: 'signIn' }, query: { redirect: to.fullPath } })
      }
      if (to.matched.some(record => record.meta.role === 'voter')) {
        next({ name: 'voteLogin', params: { mid: 'scan', cid: 0 } })
      }
      if (to.matched.some(record => record.meta.role === 'wj_answer')) {
        next({ name: 'answerLogin', params: { cid: to.params.cid, mid: to.params.mid, qid: to.params.qid } })
      }
    } else {
      if (state.isLogin) {
        if (state.token != null && state.issued != null && state.expires_in != null) {
          const date = new Date().getTime()
          if (date - new Date(state.issued).getTime() < state.expires_in * 1000) {
            if (to.matched.some(record => record.meta.role === state.role)) {
              if (from.query.site && !to.query.site) {
                const tempQuery = to.query
                tempQuery.site = from.query.site
                next({ name: to.name, params: to.params, query: tempQuery })
              } else {
                next()
              }
            } else {
              messageWarningTip('账户没有权限访问，请先登录！')
              if (to.matched.some(record => record.meta.role === 'user')) {
                next({ name: 'login', params: { loginType: 'signIn' }, query: { redirect: to.fullPath } })
              }
              if (to.matched.some(record => record.meta.role === 'voter')) {
                next({ name: 'voteLogin', params: { mid: 'scan', cid: 0 } })
              }
              if (to.matched.some(record => record.meta.role === 'wj_answer')) {
                next({ name: 'answerLogin', params: { cid: to.params.cid, mid: to.params.mid, qid: to.params.qid } })
              }
            }
          } else {
            messageWarningTip('登录已过有效期，请重新登录！')
            window.localStorage.removeItem('state')
            if (to.matched.some(record => record.meta.role === 'user')) {
              next({ name: 'login', params: { loginType: 'signIn' }, query: { redirect: to.fullPath } })
            }
            if (to.matched.some(record => record.meta.role === 'voter')) {
              next({ name: 'voteLogin', params: { mid: 'scan', cid: 0 } })
            }
            if (to.matched.some(record => record.meta.role === 'wj_answer')) {
              next({ name: 'answerLogin', params: { cid: to.params.cid, mid: to.params.mid, qid: to.params.qid } })
            }
          }
        } else {
          messageWarningTip('无权访问，请先登录！')
          window.localStorage.removeItem('state')
          if (to.matched.some(record => record.meta.role === 'user')) {
            next({ name: 'login', params: { loginType: 'signIn' }, query: { redirect: to.fullPath } })
          }
          if (to.matched.some(record => record.meta.role === 'voter')) {
            next({ name: 'voteLogin', params: { mid: 'scan', cid: 0 } })
          }
          if (to.matched.some(record => record.meta.role === 'wj_answer')) {
            next({ name: 'answerLogin', params: { cid: to.params.cid, mid: to.params.mid, qid: to.params.qid } })
          }
        }
      } else {
        messageWarningTip('无权访问，请先登录！')
        window.localStorage.removeItem('state')
        if (to.matched.some(record => record.meta.role === 'user')) {
          next({ name: 'login', params: { loginType: 'signIn' }, query: { redirect: to.fullPath } })
        }
        if (to.matched.some(record => record.meta.role === 'voter')) {
          next({ name: 'voteLogin', params: { mid: 'scan', cid: 0 } })
        }
        if (to.matched.some(record => record.meta.role === 'wj_answer')) {
          next({ name: 'answerLogin', params: { cid: to.params.cid, mid: to.params.mid, qid: to.params.qid } })
        }
      }
    }
  } else {
    next()
  }
})

const routerMethods = ['push', 'replace']
routerMethods.forEach(method => {
  const originalCall = VueRouter.prototype[method]
  VueRouter.prototype[method] = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalCall.call(this, location, onResolve, onReject)
    }
    return originalCall.call(this, location).catch(err => err)
  }
})

export default router
